import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate
} from "react-router-dom";
import ClientDetails from "./pages/Client-Details";
import ProjectDetails from "./pages/Project-Details";
import UploadFile from "./pages/UploadFile";
import Milestones from "./pages/Milestones";
import ProjectPhasesDetails from "./pages/ProjectPhasesDetails";
import "./App.css";
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider, useAuth } from "./context/AuthContext";

function DashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [openProjects, setOpenProjects] = useState(
    location.pathname.startsWith("/project")
  );

  const handleLogout = () => {
    logout();
    navigate("/admin-login");
  };

  return (
    <div className="app-wrapper">
      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <button
          className="sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? "Open Menu" : "Close Menu"}
        >
          {collapsed ? "➡" : "⬅"}
        </button>

        <div className="sidebar-header">
          <h2>💰 Finance Portal</h2>
        </div>

        <nav className="sidebar-nav">
          <Link
            to="/upload-file"
            className={`nav-item ${location.pathname === "/upload-file" ? "active" : ""}`}
          >
            <span className="nav-icon">📤</span>
            <span className="nav-text">Upload File</span>
          </Link>

          <Link
            to="/client-details"
            className={`nav-item ${location.pathname === "/client-details" ? "active" : ""}`}
          >
            <span className="nav-icon">📄</span>
            <span className="nav-text">Client Details</span>
          </Link>
 {/* Collapsible Projects section */}
          <div
            className={`nav-item ${location.pathname.startsWith("/project") ? "active" : ""}`}
            onClick={() => setOpenProjects(!openProjects)}
            style={{ cursor: "pointer" }}
          >
            <span className="nav-icon">📊</span>
            <span className="nav-text">Projects</span>
            <span className="nav-arrow">{openProjects ? "▾" : "▸"}</span>
          </div>

          {openProjects && (
            <div className="nav-submenu">
              <Link
                to="/project-details"
                className={`nav-item sub ${
                  location.pathname === "/project-details" ? "active" : ""
                }`}
              >
                <span className="nav-text">All Project Details</span>
              </Link>
              <Link
                to="/project-phases-details"
                className={`nav-item sub ${
                  location.pathname === "/project-phases-details" ? "active" : ""
                }`}
              >
                <span className="nav-text">Project Phases Details</span>
              </Link>
            </div>
          )}
          
          <Link
            to="/milestones"
            className={`nav-item ${location.pathname === "/milestones" ? "active" : ""}`}
          >
            <span className="nav-icon">📄</span>
            <span className="nav-text">Milestones</span>
          </Link>

         
        </nav>
      </aside>

      <div className={`main-wrapper ${collapsed ? "expanded" : ""}`}>
        {/* Topbar */}
        <header className="topbar">
          <span className="topbar-title">Finance Portal</span>
          <button className="logout-btn" onClick={handleLogout}>
            🚪 Logout
          </button>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<ProtectedRoute><UploadFile /></ProtectedRoute>} />
            <Route path="/upload-file" element={<ProtectedRoute><UploadFile /></ProtectedRoute>} />
            <Route path="/client-details" element={<ProtectedRoute><ClientDetails /></ProtectedRoute>} />
            <Route path="/project-details" element={<ProtectedRoute><ProjectDetails /></ProtectedRoute>} />
            <Route path="/project-phases-details" element={<ProtectedRoute><ProjectPhasesDetails /></ProtectedRoute>} />
            <Route path="/milestones" element={<ProtectedRoute><Milestones /></ProtectedRoute>} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/*" element={<DashboardLayout />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;